import { createContext, useContext, useState } from 'react';

const PageContext = createContext({ page: 'unknown', setPage: () => {} });

export function PageProvider({ children }) {
  const [page, setPage] = useState('portfolio-command');
  return <PageContext.Provider value={{ page, setPage }}>{children}</PageContext.Provider>;
}

export function usePage() { return useContext(PageContext); }
